module.exports = __webpack_public_path__ + "assets/f82ea66c5899a6eef84e6209f0b3af89.png";